import { Action } from 'models/Action';
import { ObjectField } from 'react3l-decorators';
import nameof from 'ts-nameof.macro';
import { DocumentPermissionFieldMapping } from './DocumentPermissionFieldMapping';


ObjectField(Action)(DocumentPermissionFieldMapping.prototype, nameof(DocumentPermissionFieldMapping.prototype.action));

export * from './DocumentPermissionFieldMapping';
